/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  SomaIcon,
  SomaPopover,
  SomaPopoverContent,
} from '@soma/react';

import { GAIN, LOSS } from 'xpi-black-ui/Styles/colors';

import Icon from 'xpi-black-ui/Base/Icon';
import Bullet from 'xpi-black-ui/Base/Bullet';
import Spinner from 'xpi-black-ui/Base/Spinner';
import Tooltip from 'xpi-black-ui/Base/Tooltip';
import Checkbox from 'xpi-black-ui/Base/Checkbox';
import { Td } from 'xpi-black-ui/Common/Table';

import { Tr } from 'components/Common/Table';
import TooltipStatus from 'components/Common/TooltipStatus';

import { Input, EmptyInfo, ClientInfo, TdFavotire, ClientStatus, ClientStatusWrapper, TooltipError } from './styles';

const TableItem = ({
  client,
  hasError,
  errors,
  isRubiYield,
  favoriteClient,
  onReLoadClient,
  onSelectedClient,
  updateClientQuantity,
}) => {
  const [onFocus, setOnFocus] = useState(false);
  const [showError, setShowError] = useState(false);
  const [open, toggleOpen] = React.useState(false);

  useEffect(() => {
    setShowError(client.hasError && client.isSelected);
  }, [client]);

  const renderQuantityInput = () => (
    <>
      <Input
        type="text"
        maxLength="13"
        placeholder="0"
        error={showError}
        value={client.quantityView}
        onFocus={() => setOnFocus(true)}
        onBlur={() => setOnFocus(false)}
        onChange={e => updateClientQuantity(client, e.target.value)}
      />
      {showError && onFocus && (
        <TooltipError data-text={client?.messageError}>
          <span />
        </TooltipError>
      )}
    </>
  );

  const renderQuantity = () => {
    if (client.habilitado) {
      return renderQuantityInput();
    }

    return <EmptyInfo />;
  };

  return (
    <Tr error={client.riskError}>
      <Td>
        {client.habilitado
          ? (
            <Checkbox
              id={client.clienteId.toString()}
              checked={client.isSelected}
              disabled={client.riskError}
              onChange={() => onSelectedClient(client)}
            />
          )
          : <EmptyInfo />
        }
      </Td>
      <TdFavotire>
        {client.favoriteClientLoading
          ? <Spinner small />
          : <Icon type="star" active={client.favorito} onClick={() => favoriteClient(client)} />
        }
      </TdFavotire>
      <Td>{client.clienteId}</Td>
      <Td>
        <ClientInfo>{client.nome}</ClientInfo>
      </Td>
      <Td>
        {renderQuantity()}
      </Td>
      <Td style={{ whiteSpace: 'inherit' }}>
        <ClientStatusWrapper justifyContent="space-between">
          {client?.mensagemErrorStatus
            ? (
              <ClientStatus>
                <TooltipStatus text={client.mensagemErrorStatus} black>
                  <Bullet color={LOSS}>{client.mensagemErrorStatus}</Bullet>
                </TooltipStatus>
              </ClientStatus>
)
            : (
              <>
                {client.habilitado
                  ? (

                  client?.riskValidated
                    ? (
                      <Bullet color={GAIN}>Habilitado para envio do push</Bullet>
                    ) : (
                      <Bullet color="#FFC709">Pendente validação risco da carteira</Bullet>
                    )
                  )
                  : (
                    <ClientStatus>
                      <Tooltip text={client.impedimentsMessage} down black>
                        <Bullet color={LOSS}>{client.impedimentsMessage}</Bullet>
                      </Tooltip>
                    </ClientStatus>
                  )
              }
              </>
          )}
        </ClientStatusWrapper>
      </Td>
      {isRubiYield && hasError && (
        <Td>
          {errors?.find(item => item.codigoCliente === client.clienteId)?.mensagem}
        </Td>
      )}
      <Td>
        <Icon type="update" onClick={() => { onReLoadClient(client.clienteId); }} />
      </Td>
    </Tr>
  );
};

TableItem.propTypes = {
  client: PropTypes.shape({}).isRequired,
  hasError: PropTypes.bool.isRequired,
  errors: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateClientQuantity: PropTypes.func.isRequired,
  onReLoadClient: PropTypes.func.isRequired,
  onSelectedClient: PropTypes.func.isRequired,
  favoriteClient: PropTypes.func,
};

export default TableItem;
